
export const CLASS_SELECT_IS_SELF_FEEDER = 'select-is-self-feeder';
export const CLASS_PLACEHOLDER_OPTION = '.feed-dzswtl--placeholder';
export const CLASS_OPTION_LABEL = '.the-label--name';
export const CLASS_FEEDER = 'dzs-style-me-feeder';
export const SELECTOR_TYPE = {
  'SELECT': 'select',
  'MULTIPLE_CHECKBOXES': 'multiple-checkboxes',
}